function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Dashboard_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "Dashboard_svg__a",
  transform: "translate(22 71)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Dashboard_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Dashboard_svg__c",
  d: "M1.618 21A12 12 0 1124 15a11.928 11.928 0 01-1.618 6zM1.5 15a10.46 10.46 0 001.022 4.5h18.956A10.5 10.5 0 101.5 15zm8.5 1.154a1.841 1.841 0 011.651-1.827L14 10l-.891 4.813A1.845 1.845 0 1110 16.154zm8.3-1.5A1.35 1.35 0 1119.651 16a1.349 1.349 0 01-1.351-1.35zM3 14.65A1.35 1.35 0 114.351 16 1.349 1.349 0 013 14.65zm13.5-4.5a1.35 1.35 0 111.35 1.35 1.349 1.349 0 01-1.35-1.35zm-11.7 0a1.35 1.35 0 111.351 1.35A1.349 1.349 0 014.8 10.15zm8.1-2.7a1.35 1.35 0 111.35 1.35 1.349 1.349 0 01-1.35-1.35zm-4.5 0A1.35 1.35 0 119.751 8.8 1.349 1.349 0 018.4 7.45z"
}));

function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgDashboard;